const THEME_KEYS = [
  'bg_color',
  'text_color',
  'hint_color',
  'link_color',
  'button_color',
  'button_text_color',
  'secondary_bg_color',
];

export function applyThemeParams(themeParams) {
  if (!themeParams) return;

  const root = document.documentElement;
  THEME_KEYS.forEach((key) => {
    const value = themeParams[key];
    if (value) {
      root.style.setProperty(`--tg-theme-${key.replace(/_/g, '-')}`, value);
    }
  });
}

export function applyColorScheme(colorScheme) {
  document.documentElement.dataset.tgColorScheme = colorScheme ?? 'light';
}

export function applyObankTheme(themeParams, colorScheme) {
  applyThemeParams(themeParams);
  applyColorScheme(colorScheme);
}
